// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Particles from 'particles.vue'
import VueFullpage from 'fullpage-vue'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../static/css/style.css'
import 'fullpage-vue/src/fullpage.css'
import VuePaginate from 'vue-paginate'
import i18n from './i18n'


import VueAnalytics from 'vue-analytics'
// import VueGtag from 'vue-gtag'
import VueGtm from 'vue-gtm';

Vue.use(VueAnalytics, {
  id: 'UA-221870785-1',
  router
})

// if (['staging', 'production'].includes(process.env.VUE_APP_MODE)) {
//     Vue.use(VueGtag, {
//       config: {
//         id: process.env.VUE_GOOGLE_ANALYTICS_KEY,
//         params: { anonymize_ip: true }
//       }
//     })
// }

Vue.use(VueGtm, {
    id: 'GTM-TDM3ZBP',
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false,
});


Vue.config.productionTip = false


Vue.use(Particles)
Vue.use(VueFullpage)
Vue.use(BootstrapVue)
Vue.use(VuePaginate)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js